import getInObject from '@insight/toolkit-utils/lib/helpers/getInObject';
import setInObject from '@insight/toolkit-utils/lib/helpers/setInObject';
import shallowEqual from '@insight/toolkit-utils/lib/helpers/shallowEqual';

import { ARRAY_ERROR, FORM_ERROR } from '../constants';
import getValidators from './getValidators';

const processErrors = ({
  fieldErrors,
  fieldKeys,
  limitedValidation,
  recordErrors,
  state,
}) => {
  const { config, fields, formState } = state;

  let merged = {
    ...(limitedValidation ? formState.errors : {}),
    ...recordErrors,
  };

  const forEachError = (fn) => {
    fieldKeys.forEach((name) => {
      if (fields[name]) {
        // make sure field is still registered here
        // field-level errors take precedence over record-level errors
        const recordError = getInObject(recordErrors, name);
        const fieldError = fieldErrors[name];
        const hasFieldLevelValidation = getValidators(fields[name]).length;
        const errorFromParent = getInObject(merged, name);
        fn(
          name,
          (hasFieldLevelValidation && fieldError) ||
            (config.validate && recordError) ||
            (!recordError && !limitedValidation ? errorFromParent : undefined)
        );
      }
    });
  };

  forEachError((name, error) => {
    merged = setInObject(merged, name, error) || {};
  });
  forEachError((name, error) => {
    if (error && error[ARRAY_ERROR]) {
      const existing = getInObject(merged, name);
      const copy = [...existing];
      copy[ARRAY_ERROR] = error[ARRAY_ERROR];
      merged = setInObject(merged, name, copy);
    }
  });

  if (!shallowEqual(formState.errors, merged)) {
    formState.errors = merged;
  }
  formState.error = recordErrors[FORM_ERROR];
};

export default processErrors;
